import { t } from 'i18next'

export const translate = (text) => {
  return t(text)
}